import { useContext } from 'react';

import Text from 'components/common/Text';
import PostSkipPencil from 'components/icons/PostSkipPencil';
import Repeat from 'components/icons/Repeat';
import { BasketContext, UserContext } from 'components/signUpFunnel/Contexts';
import { basketCutoffLocalTimeNoZone, thankYouBasketCutoffDate } from 'helpers/timeFormat';

const ThankYouSubscriptionStatus = () => {
  const { basket } = useContext(BasketContext);
  const { user } = useContext(UserContext);
  const { weeklyMeals } = user;

  return (
    <aside
      className="col-span-1 flex w-full flex-col gap-6 px-0 py-6 bp2:gap-8 bp2:px-6"
      aria-label="Subscription details"
    >
      <div className="flex gap-3 bp2:flex-col bp2:gap-2">
        <PostSkipPencil className="h-8 w-8 shrink-0 bp2:h-12 bp2:w-12" />
        <div className="flex flex-col gap-1 bp2:gap-2">
          <Text brandStylesOverrides="textMd bp1:h6 bp1:text-secondary">
            Edit by {thankYouBasketCutoffDate(basket?.editingCutoff)} at{' '}
            {basketCutoffLocalTimeNoZone(basket?.editingCutoff)}
          </Text>
          <Text brandStylesOverrides="textSm bp1:text text-charcoal-80">
            Order confirmed and your card is charged.
          </Text>
        </div>
      </div>
      <div className="flex gap-3 bp2:flex-col bp2:gap-2">
        <Repeat className="h-8 w-8 shrink-0 bp2:h-12 bp2:w-12" />
        <div className="flex flex-col gap-1 bp2:gap-2">
          <Text brandStylesOverrides="textMd bp1:h6 bp1:text-secondary">
            {`You'll enjoy ${weeklyMeals} meals per week`}
          </Text>
          <Text brandStylesOverrides="textSm bp1:text text-charcoal-80">
            Skip or cancel anytime.
          </Text>
        </div>
      </div>
    </aside>
  );
};

export default ThankYouSubscriptionStatus;
